var path = '/static/assets/khapps/external/niabcuf/partials/tempitem_edit.html';
var html = "<md-button ng-click=\"editItem()\" class=\"md-fab md-mini md-primary md-raised\" aria-label=\"Edit\">\n    <md-icon md-svg-icon=\"pencil\"></md-icon>\n</md-button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;